<template>
  <div>
    <h1 class="onboarding__title mb-15">
      {{ $t('onboarding.address.title') }}
    </h1>

    <v-form ref="form" @submit.prevent="validate" lazy-validation>
      <div class="px-2">
        <AddressSearch
          @address="setGoogleAddress"
          :rules="[rules.required]"
          :loading="isLoading"
          :value="address"
          :validate="false"
          ref="addressSearch"
        />

        <v-row>
          <v-col>
            <v-text-field
              v-model="streetNumber"
              :rules="[rules.required]"
              :label="$t('forms.addressNumber')"
              outlined
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="postalCode"
              v-mask="'#####-###'"
              :rules="[rules.postalCode]"
              :label="$t('forms.zipCode')"
              outlined
            />
          </v-col>
        </v-row>
      </div>

      <v-row class="mt-10" no-gutters>
        <v-col class="text-right">
          <v-btn
            @click="validate"
            :disabled="isCheckingAddress"
            :loading="isLoading"
            color="primary"
            elevation="0"
            large
          >
            {{ $t('onboarding.actions.next') }}
            <v-icon right small> mdi-chevron-right </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import AddressSearch from '@/components/app/AddressSearch'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { required, postalCode } from '@/util/errorHandling'

export default {
  name: 'OnboardingStepsCity',

  components: {
    AddressSearch,
  },

  data() {
    return {
      address: '',
      streetNumber: '',
      postalCode: '',
      isCheckingAddress: true,
      rules: {
        required,
        postalCode,
      },
    }
  },

  watch: {
    onboardingProfile({ address, streetNumber, postalCode }) {
      if (!address) return

      this.address = address
      this.postalCode = postalCode
      this.streetNumber = streetNumber
    },
  },

  computed: {
    ...mapGetters([
      'isLoading',
      'onboardingProfile',
      'onboardingStepsNavigation',
      'onboardingStepsNextEnabled',
    ]),
  },

  methods: {
    ...mapActions(['onboardingCreateAddress']),
    ...mapMutations([
      'setOnboardingStepsNavigation',
      'setOnboardingProfile',
      'setIsLoading',
    ]),

    setGoogleAddress(fullAddress) {
      Promise.resolve(fullAddress)
        .then((response) => {
          this.address = response?.address
          this.postalCode = response?.postalCode
          this.streetNumber = response?.streetNumber
        })
        .finally(() => {
          this.isCheckingAddress = false
        })
    },

    parseJwt() {
      const token = localStorage.getItem('access_token')

      var base64Url = token.split('.')[1]
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
          })
          .join('')
      )

      return JSON.parse(jsonPayload)
    },

    validate() {
      if (
        !this.isCheckingAddress &&
        this.postalCode &&
        this.streetNumber &&
        this.$refs.form.validate()
      ) {
        const addressData = {
          address: this.address,
          streetNumber: this.streetNumber,
          postalCode: this.postalCode.replace(/\D/g, ''),
        }
        this.setOnboardingProfile(addressData)
        this.onboardingCreateAddress(addressData)
      }
    },
  },
}
</script>
